import { render } from "./Home.vue?vue&type=template&id=1a9872cb&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1a9872cb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a9872cb"

export default script